import {createRouter, createWebHistory} from 'vue-router'
import SitesView from '@/views/SitesView';
// import BuilderView from '@/views/BuilderView';

const routes = [
	{
		path: '/',
		name: 'Sites',
		alias: '/sites',
		component: SitesView,
	},
  {
		path: '/builder/:id',
		name: 'Builder',
		// alias: '/builder/:id',
		// component: BuilderView,
    component: () => import(/* webpackChunkName: "article" */ "@/views/BuilderView.vue")
	},
  {
		path: '/stat/:id',
		name: 'MatomoStat',
    component: () => import(/* webpackChunkName: "article" */ "@/views/MatomoStatView.vue"),
	},
	{
		path: '/:pathMatch(.*)*',
		name: '404',
		redirect: '/'
	}
]

const router = createRouter({
	// history: createWebHistory(process.env.BASE_URL), //process.env.BASE_URL
	history: createWebHistory('/site/'),
	routes
})

// router.beforeEach((to, from, next) => {
	
// });
// router.afterEach(to => {

// })

// router.beforeResolve((to, from) => {

// })

export default router
